import React, { memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Form, FormFeedback, Input, InputGroup, Label, Row } from 'reactstrap';

import { Button, Card, Flex } from 'antd';

import { sendContactUs } from '../../../redux/actions/user';

import { successToastHandler } from '../../../components/action_notifier';

import './styles.scss';

const ContactUs = ({ history }) => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);

  const [state, setState] = useState({
    subject: null,
    message: null
  });
  const [touchedFields, setTouchedFields] = useState({ subject: false, message: false });

  const onChangeField = (e, field) => {
    setTouchedFields(prevState => ({ ...prevState, [field]: true }));
    setState(prevState => ({ ...prevState, [field]: e.target.value }));
  };

  const onClickSubmit = () => {
    const payload = {
      subject: state.subject,
      message: state.message,
      email: user.user.email
    };

    dispatch(sendContactUs(payload))
      .then(res => {
        if (res.id) {
          history.goBack();
        }

        setTouchedFields({ subject: false, message: false });
        setState({ subject: '', message: '' });

        successToastHandler(res.message);
      })
      .catch(e => {
        console.error(e);
      });
  };

  const onClickCancel = () => {
    history.goBack();
  };
  return (
    <div className="contact-us-page">
      <Row>
        <h4 className="">Contact us</h4>
      </Row>

      <Card className="mb-2">
        <Form className="mt-3" id="contactUs" action="/dashboard">
          <Label for="subject" className="required-field">
            Subject
          </Label>
          <InputGroup className="mb-2">
            <Input
              type="subject"
              id="subject"
              name="subject"
              value={state.subject}
              onChange={e => onChangeField(e, 'subject')}
              placeholder="Subject"
              valid={state.subject?.length}
              invalid={touchedFields.subject && !state.subject?.length && state.subject !== null}
            />
            <FormFeedback>Required</FormFeedback>
          </InputGroup>
          <Label for="message" className="required-field">
            Message
          </Label>
          <Input
            type="textarea"
            rows="5"
            id="message"
            placeholder="Message"
            value={state.message}
            onChange={e => onChangeField(e, 'message')}
            valid={state.message?.length}
            invalid={touchedFields.message && !state.message?.length && state.message !== null}
          />
          <FormFeedback>Required</FormFeedback>
        </Form>
      </Card>
      <Flex gap="small" justify="end">
        <Button size="large" onClick={onClickCancel}>
          Cancel
        </Button>
        <Button
          size="large"
          type="primary"
          onClick={onClickSubmit}
          disabled={!state.message?.length || !state.subject?.length}>
          Submit
        </Button>
      </Flex>
    </div>
  );
};

export default memo(ContactUs);
